import * as React from "react";

export const FontSizeIcon = React.memo(({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      aria-hidden="true"
      focusable="false"
    >
      <path d="M8 4C8.732 4 9.381 4.473 9.605 5.17L13.952 18.694C14.121 19.22 13.832 19.783 13.306 19.952C12.78 20.121 12.217 19.832 12.048 19.306L10.664 15H5.336L3.952 19.306C3.783 19.832 3.22 20.121 2.694 19.952C2.168 19.783 1.879 19.22 2.048 18.694L6.395 5.17C6.619 4.473 7.268 4 8 4ZM18 12C18.765 12 19.481 12.215 20.089 12.588C20.246 12.241 20.595 12 21 12C21.552 12 22 12.448 22 13V19C22 19.552 21.552 20 21 20C20.595 20 20.246 19.759 20.089 19.412C19.481 19.785 18.765 20 18 20C15.791 20 14 18.209 14 16C14 13.791 15.791 12 18 12ZM8 6.712L5.979 13H10.021L8 6.712ZM18 14C16.895 14 16 14.895 16 16C16 17.105 16.895 18 18 18C19.105 18 20 17.105 20 16C20 14.895 19.105 14 18 14Z" />
    </svg>
  );
});

FontSizeIcon.displayName = "FontSizeIcon";
